import React from 'react';
import VisitorTracker from './VisitorTracker';

function App() {
  return (
    <div className="App">
      <VisitorTracker />
    </div>
  );
}

export default App;
